module.exports = __webpack_public_path__ + "img/05.c17df03b.jpg";